module.exports = __webpack_public_path__ + "assets/img/fenxi.bbe1fda3.png";